module.exports = __webpack_public_path__ + "static/img/map5.2d67260.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/map5.png
// module id = kjqY
// module chunks = 0